import {
  MagicCard as BaseMagicCard,
  type MagicCardProps,
} from "@/components/ui/magic-card"

export function MagicCard(props: MagicCardProps) {
  if (props.mode === "orb") {
    return (
      <BaseMagicCard
        glowFrom="var(--warning)"
        glowTo="var(--chart-4)"
        {...props}
      />
    )
  }
  return (
    <BaseMagicCard
      gradientColor="var(--muted)"
      gradientFrom="var(--primary)"
      gradientTo="var(--accent)"
      {...props}
    />
  )
}

export type { MagicCardProps }
